import type { IPractice } from "@common-shared/types/responseData/commonResponseData.types.ts"
import {
    IOneVerifyOrganizationUserInvite,
    IOneVerifyPracticeUsageQuotaExtended,
    IOneVerifyProfile,
} from "@common-shared/types/responseData/oneVerifyResponseData.types.ts"

import { API_ROUTES } from "../config/routes.config"
import { HttpHelper } from "../helpers/http.helper"
import { UtilHelper } from "../helpers/util.helper.tsx"

export class UserDetailsService {
    /**
     * Get user profile
     */
    static async getProfile(): Promise<IOneVerifyProfile | undefined> {
        const result = await HttpHelper.sendRequest(API_ROUTES.PROFILE_GET)

        return !UtilHelper.isEmptyObject(result) && !result.errorData
            ? result
            : undefined
    }

    /**
     * Accept invitation to some practice by user
     */
    static async acceptUserInvitation(
        invite: IOneVerifyOrganizationUserInvite,
    ): Promise<IOneVerifyProfile | undefined> {
        const result = await HttpHelper.sendRequest(
            API_ROUTES.PROFILE_ACCEPT_ORG_INVITATION.replace(
                ":inviteToken",
                invite.inviteToken,
            ),
            undefined,
            "POST",
        )

        return !UtilHelper.isEmptyObject(result) && !result.errorData
            ? result
            : undefined
    }

    /**
     * Get practice usage quota
     */
    static async getPracticeUsageQuota(
        practice: IPractice,
    ): Promise<IOneVerifyPracticeUsageQuotaExtended | undefined> {
        const result = await HttpHelper.sendRequest(
            API_ROUTES.PRACTICE_GET_USAGE_QUOTA.replace(
                ":practiceId",
                practice.id.toString(),
            ),
        )

        return !UtilHelper.isEmptyObject(result) && !result.errorData
            ? result
            : undefined
    }
}
